import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router'
import PageNotFoundError from '@/components/errors/pageNotFoundError.jsx'
// import Header from '@/components/header/header.jsx'
// import Share from '@/components/ui/share/share.jsx'
// import { TooltipProvider } from '@/components/ui/tooltip.jsx'
import { observer } from 'mobx-react-lite'
import useStore from '@/hooks/useStore.js'
// import {
//   LoadingIndicator,
//   LoadingIndicatorSubTitle,
//   LoadingIndicatorTitle,
// } from '@/components/ui/loadingIndicator.jsx'
import { useEffect } from 'react'
// import LegalNoticePage from '@/components/pages/LegalNoticePage.jsx'
// import RegisterPage from '@/components/pages/RegisterPage.jsx'
// import OfflineError from '@/components/errors/offlineError.jsx'
// import HeaderSafety from '@/components/header/headerSafety.jsx'
// import { cn } from '@/utils/ui.js'
// import HeaderBottomMobile from '@/components/header/headerBottomMobile.jsx'
// import { Toaster } from '@/components/ui/sonner.jsx'
import PromeetClosedError from '@/components/errors/promeetClosedError.jsx'

// TODO: regenerate PWA images and include screenshot for rich install experience
// TODO: separate PWA icons for staging and dev envs

const isOnramper = window.location.pathname.startsWith('/onramper')

const App = () => {
  const router = useRouter()
  const rootStore = useStore()
  const { appStore, /*authStore,*/ fingerprintStore, routerStore } = rootStore

  useEffect(() => {
    if (
      !appStore.isInitialized ||
      rootStore.isInitializing ||
      rootStore.isInitialized ||
      appStore.isOffline
    )
      return

    rootStore.init().then(async () => {
      routerStore.init(router)
      // if (isOnramper) return
      // await fingerprintStore.init()
    })
  }, [appStore.isInitialized, appStore.isOffline, fingerprintStore, rootStore, router, routerStore])

  if (isOnramper) return <Outlet />

  return <PromeetClosedError />

  // if (!appStore.isInitialized)
  //   return (
  //     <LoadingIndicator>
  //       {appStore.isUpdating ? (
  //         <>
  //           <LoadingIndicatorTitle>Updating...</LoadingIndicatorTitle>
  //           <LoadingIndicatorSubTitle>(this may take a moment)</LoadingIndicatorSubTitle>
  //         </>
  //       ) : (
  //         <LoadingIndicatorTitle>Checking for updates...</LoadingIndicatorTitle>
  //       )}
  //     </LoadingIndicator>
  //   )
  //
  // if (appStore.isReloading)
  //   return (
  //     <LoadingIndicator>
  //       <LoadingIndicatorTitle>Restarting...</LoadingIndicatorTitle>
  //     </LoadingIndicator>
  //   )
  //
  // if (
  //   (!fingerprintStore.isInitialized && !fingerprintStore.hasFingerprint) ||
  //   !routerStore.isInitialized
  // )
  //   return (
  //     <LoadingIndicator>
  //       <LoadingIndicatorTitle>Getting ready...</LoadingIndicatorTitle>
  //     </LoadingIndicator>
  //   )
  //
  // if (fingerprintStore.isInitialized && fingerprintStore.mustAcceptLegalDocs)
  //   return <LegalNoticePage />
  //
  // if (!authStore.isInitialized && !fingerprintStore.isBot)
  //   return (
  //     <LoadingIndicator>
  //       <LoadingIndicatorTitle>Starting...</LoadingIndicatorTitle>
  //     </LoadingIndicator>
  //   )
  //
  // if (authStore.mustFinishRegistration) return <RegisterPage />
  //
  // return (
  //   <TooltipProvider>
  //     <HeaderSafety />
  //     <Header />
  //     <HeaderBottomMobile />
  //
  //     <AppMain />
  //
  //     <Toaster />
  //     <Share />
  //     <OfflineError />
  //   </TooltipProvider>
  // )
}

// const AppMain = observer(() => {
//   const { routerStore } = useStore()
//
//   return (
//     <main
//       className={cn('flex grow flex-col md:mt-17', {
//         'md:p-6': !routerStore.isMeetingPage && !routerStore.isLivestreamPage,
//       })}
//       style={{
//         marginBottom: 'var(--mobile-header-height, 0px)',
//         marginTop: 'var(--header-height, 0px)',
//       }}>
//       <Outlet />
//     </main>
//   )
// })

export const Route = createRootRoute({
  component: observer(App),
  notFoundComponent: PageNotFoundError,
})
